var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var resizeImage = function (file, options) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                var img = new Image();
                if (!ctx) {
                    reject(new Error("Failed to get canvas context"));
                    return;
                }
                img.onload = function () {
                    canvas.width = options.width;
                    canvas.height = options.height;
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = "high";
                    if (options.format === "jpeg") {
                        ctx.fillStyle = "#FFFFFF";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    var scale = Math.max(canvas.width / img.width, canvas.height / img.height);
                    var scaledWidth = img.width * scale;
                    var scaledHeight = img.height * scale;
                    var x = (canvas.width - scaledWidth) / 2;
                    var y = (canvas.height - scaledHeight) / 2;
                    ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
                    canvas.toBlob(function (blob) {
                        if (!blob) {
                            reject(new Error("Failed to create blob from canvas"));
                            return;
                        }
                        var format = options.format || "jpeg";
                        var mimeType = "image/".concat(format);
                        var fileName = file.name.replace(/\.[^/.]+$/, ".".concat(format));
                        resolve(new File([blob], fileName, { type: mimeType, lastModified: Date.now() }));
                    }, "image/".concat(options.format || "jpeg"), options.quality || 0.8);
                };
                img.onerror = function () { return reject(new Error("Failed to load image")); };
                img.src = URL.createObjectURL(file);
            })];
    });
}); };
export var resizeBannerImage = function (file_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([file_1], args_1, true), Promise, function (file, targetWidth) {
        if (targetWidth === void 0) { targetWidth = 2000; }
        return __generator(this, function (_a) {
            return [2 /*return*/, resizeImage(file, {
                    width: targetWidth,
                    height: Math.round(targetWidth / 5),
                    quality: 0.85,
                    format: "jpeg",
                })];
        });
    });
};
export var resizeAvatarImage = function (file_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([file_1], args_1, true), Promise, function (file, size) {
        if (size === void 0) { size = 400; }
        return __generator(this, function (_a) {
            return [2 /*return*/, resizeImage(file, { width: size, height: size, quality: 0.9, format: "jpeg" })];
        });
    });
};
export var shouldResizeImage = function (file_1, targetWidth_1, targetHeight_1) {
    var args_1 = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([file_1, targetWidth_1, targetHeight_1], args_1, true), Promise, function (file, targetWidth, targetHeight, tolerance) {
        if (tolerance === void 0) { tolerance = 50; }
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var img = new Image();
                    img.onload = function () {
                        var needsResize = Math.abs(img.width - targetWidth) > tolerance ||
                            Math.abs(img.height - targetHeight) > tolerance;
                        URL.revokeObjectURL(img.src);
                        resolve(needsResize);
                    };
                    img.onerror = function () { return reject(new Error("Failed to load image for size check")); };
                    img.src = URL.createObjectURL(file);
                })];
        });
    });
};
export var getImageDimensions = function (file) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    URL.revokeObjectURL(img.src);
                    resolve({ width: img.width, height: img.height });
                };
                img.onerror = function () { return reject(new Error("Failed to load image for dimension check")); };
                img.src = URL.createObjectURL(file);
            })];
    });
}); };
export var processImageFile = function (file, _type) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        if (file.size > 5 * 1024 * 1024)
            throw new Error("Файл слишком большой (максимум 5 МБ)");
        return [2 /*return*/, file];
    });
}); };
export var cropImageToFile = function (imageSrc, pixelCrop, type) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = pixelCrop.width;
            canvas.height = pixelCrop.height;
            var ctx = canvas.getContext("2d");
            if (!ctx)
                return reject(new Error("Canvas context unavailable"));
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);
            canvas.toBlob(function (blob) {
                if (!blob)
                    return reject(new Error("Failed to create blob"));
                resolve(new File([blob], "".concat(type, ".jpg"), { type: "image/jpeg", lastModified: Date.now() }));
            }, "image/jpeg", 0.92);
        };
        image.onerror = function () { return reject(new Error("Failed to load image")); };
        image.src = imageSrc;
    });
};
